'use strict'

PageSpinner = require '../views/spinner'

module.exports =
  firstRunningInstance: null
  runningSpinnerCount: 0
  spinners: {}

  start: (name, options) ->
    spinner = @spinners[name] ?= new PageSpinner options
    return if spinner.isRunning

    @runningSpinnerCount++

    if @firstRunningInstance
      spinner.startRunning()
      return

    @firstRunningInstance = spinner
    spinner.render()

  stop: (name) ->
    return unless (spinner = @spinners[name])?.isRunning

    @runningSpinnerCount--

    if @runningSpinnerCount > 0
      spinner.stopRunning()
      return

    if @firstRunningInstance
      @firstRunningInstance.startRunning()
      @firstRunningInstance.close()
      @firstRunningInstance = null
